import React from 'react'
import { useSelector } from 'react-redux'

import { getVisible } from 'selectors/elements/modals/policyMigrator'

import Modal from 'components/Modal'

import ModalContent from 'components/ModalContent'

import PolicyMigrator from './PolicyMigrator'


export default function PolicyMigratorModal() {
  const isVisible = useSelector(getVisible)

  return (
    <Modal
      show={ isVisible }
    >
      <ModalContent>
        <PolicyMigrator />
      </ModalContent>
    </Modal>
  )
}
